module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<form class="form-horizontal" id="insertInstanceForm">\r\n\r\n\r\n    <div class="modal-dialog modal-lg" role="document">\r\n        <div class="modal-content">\r\n            <div class="modal-header">\r\n                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>\r\n                <h2 class="modal-title" id="myModalLabel">\r\n                    ';
if(!attributes.id){print(lang.INSERT_ENVIROMENT);} else {print(lang.EDIT_ENVIROMENT);}
__p+='\r\n                </h2>\r\n            </div>\r\n            <div class="modal-body">\r\n\r\n                <div class="col-md-12 form-group">\r\n                    <div class="col-md-3 col-xs-12 text-right">\r\n                        <label class="control-label" for="name">'+
((__t=(lang.NAME))==null?'':_.escape(__t))+
':</label>\r\n                    </div>\r\n                    <div class="col-md-9 col-xs-12">\r\n                        <input type="text" class="form-control" id="name" placeholder="'+
((__t=(lang.NAME))==null?'':_.escape(__t))+
'" required value="'+
((__t=(attributes.name))==null?'':_.escape(__t))+
'">\r\n                    </div>\r\n                </div>\r\n                <div class="col-md-12 form-group">\r\n                    <div class="col-md-3 col-xs-12 text-right">\r\n                        <label class="control-label" for="name">'+
((__t=(lang.TYPE))==null?'':_.escape(__t))+
':</label>\r\n                    </div>\r\n                    <div class="col-md-9 col-xs-12">\r\n                        <select id="type" name="type" class="form-control" required>\r\n                    <option value="epigraphs" '+
((__t=(attributes.type==="epigraphs"?'selected':''))==null?'':_.escape(__t))+
'>'+
((__t=(lang.EPIGRAFES))==null?'':_.escape(__t))+
'</option>\r\n                    <option value="areas" '+
((__t=(attributes.type==="areas"?'selected':''))==null?'':_.escape(__t))+
'>'+
((__t=(lang.A_FUNC))==null?'':_.escape(__t))+
'</option>\r\n                </select>\r\n                    </div>\r\n                </div>\r\n\r\n                <!-- tiene o no mapa -->\r\n                ';
 
 
                    var selectTiensi  = '';
                    if(attributes.is_mapa == 1){
                        selectTiensi = 'selected';
                    }
                    
                    var selectTienno  = '';
                    if(attributes.is_mapa == 0){
                        selectTienno = 'selected';
                    }

 
    
__p+='\r\n\r\n                    <div class="col-md-12 form-group">\r\n                        <input type="hidden" value="'+
((__t=(attributes.coregis_id))==null?'':_.escape(__t))+
'" name="id_core_gis_a" id="id_core_gis_a">\r\n                        <div class="col-md-3 col-xs-12 text-right">\r\n                            <label class="control-label" for="name">GIS:</label>\r\n                        </div>\r\n                        <div class="col-md-9 col-xs-12">\r\n                            <select id="is_mapa" name="is_mapa" class="form-control" required> \r\n                                <option value="1" '+
((__t=(selectTiensi))==null?'':_.escape(__t))+
'>SI</option>  \r\n                                <option value="0" '+
((__t=(selectTienno))==null?'':_.escape(__t))+
'>NO</option>   \r\n                            </select>\r\n                        </div>\r\n                    </div>\r\n\r\n\r\n                    <div class="col-md-12 form-group">\r\n                        <div class="col-md-3 col-xs-12 text-right">\r\n                            <label class="control-label" for="icon">'+
((__t=(lang.ICON))==null?'':_.escape(__t))+
':</label>\r\n                        </div>\r\n                        <div class="col-md-9 col-xs-12">\r\n                            <input type="file" class="form-control" id="icon">\r\n                        </div>\r\n                    </div>\r\n                    <div class="clear"></div>\r\n            </div>\r\n            <div class="modal-footer">\r\n                <div class="col-xs-4">\r\n                </div>\r\n                <div class="col-xs-8 text-right">\r\n                    <button type="submit" class="btn btn-primary" id="post">'+
((__t=(lang.SAVE))==null?'':_.escape(__t))+
'</button>\r\n                    <button type="reset" class="btn btn-default" id="cancel">'+
((__t=(lang.ABANDON))==null?'':_.escape(__t))+
'</button>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</form>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/views/instances/insertInstanceView.ejs
// module id = 421
// module chunks = 0